import { Add } from "@mui/icons-material";
import { Button, ButtonProps, Typography } from "@mui/material";

interface IProps extends ButtonProps {
    addRow: () => void;
}

const ProjectSizeAccordionAddPlugButton: React.FC<IProps> = ({ addRow, sx }) => {
    return (
        <Button
            LinkComponent={"button"}
            href="#"
            onClick={addRow}
            id="add-another-plug"
            sx={{
                height: "100%",
                ...sx,
            }}
        >
            <Add sx={{ verticalAlign: "middle" }} />
            <Typography
                component={"span"}
                style={{ fontWeight: 800, fontSize: "14px" }}
                sx={{ ml: 1, textDecoration: "underline" }}
            >
                Add Another
            </Typography>
        </Button>
    );
};

export default ProjectSizeAccordionAddPlugButton;
